module.exports = __webpack_public_path__ + "img/关.ea2cafa0.png";